module.exports = __webpack_public_path__ + "img/inline-mobile-english.3f9e7030.png";